import { apiSlice } from 'api/apiSlice';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getApplications: builder.query<any, any>({
      query: (params) => {
        return {
          url: '/placement-application',
          params: params,
        };
      },
      transformResponse: (res: any) => res.data,
      providesTags: ['Applications'],
    }),
    updateApplication: builder.mutation({
      query(data: any) {
        const { ...body } = data;
        return {
          url: `/placement-application/view-notification`,
          method: 'PUT',
          body,
        };
      },
      // Invalidates all queries that subscribe to the `Partner`.
      invalidatesTags: ['Applications'],
    }),
  }),
});

export const { useGetApplicationsQuery, useUpdateApplicationMutation } =
  extendedApiSlice;
